<mat-stepper [orientation]="(stepperOrientation | async)!">
    <ng-template matStepperIcon="edit" let-index="index">
        {{ index + 1 }}
    </ng-template>

    <mat-step name="1-SelectCountry">
        <div class="containerStepper">
            <ng-template matStepLabel>
                <span translate>INDUSTRY.CHOOSE_COUNTRY</span><br />
                <span
                    *ngIf="this.magocloudService?.countryValue != 'none' && this.magocloudService?.countryValue != ''"
                    style="font-size: 0.8rem"
                    >({{ this.magocloudService?.countryDescri }})</span
                >
            </ng-template>
            <ms-country-selection
                (countrySelectedDescri)="selectedDescri($event)"
                (countrySelectedValue)="selectedValue($event)"
                [isModifyStatus]="this.magocloudService?.isModifyStatus && !this.storeRoleService.IsInternal"
                [isMagoWeb]="true"
            ></ms-country-selection>
            <div class="text-center">
                <button mat-stroked-button color="secondary" matStepperPrevious *ngIf="!this.magocloudService.subscriptionNfs">
                    {{ this.backString }}
                </button>
                <button mat-stroked-button color="secondary" [disabled]="setCountryDisabled()" matStepperNext>
                    {{ this.nextString }}
                </button>
            </div>
            <div *ngIf="!this.functLoaded">
                <tb-loading></tb-loading>
            </div>
        </div>
    </mat-step>

    <mat-step name="2-SelectOptions" *ngIf="this.storeRoleService.IsInternal">
        <ng-template matStepLabel>
            <div *ngIf="this.storeRoleService?.IsInternal">
                <span translate>INDUSTRY_CONFIGURATOR.SELECT_CONFIGURATION_OPTIONS</span>
                <span *ngIf="this.subTypeSelected != '' && this.subTypeSelected != 'none'">(</span>
                <span *ngIf="this.subTypeSelected != '' && this.subTypeSelected != 'none'" style="font-size: 0.8rem">
                    {{ this.subTypeSelectedDescri }},
                </span>
                <span *ngIf="this.instanceKey != '' && this.instanceKey != 'none'" style="font-size: 0.8rem">
                    {{ this.instanceselectedDescri }},
                </span>
                <span *ngIf="this.dbSelected != '' && this.dbSelected != 'none'" style="font-size: 0.8rem">
                    {{ this.dbSelectedDescri }}
                </span>
                <span *ngIf="this.subTypeSelected != '' && this.subTypeSelected != 'none'">)</span>
            </div>
        </ng-template>
        <div class="row mt-2 d-flex" style="margin: 3em" *ngIf="this.storeRoleService?.IsInternal">
            <div class="col-xl-6 columnCalVisibility">
                showallOptions{{ showallOptions }}
                <div *ngIf="this.showallOptions" class="containerStepper">
                    <div class="EditionNameStyle" translate>INDUSTRY_CONFIGURATOR.SELECT_SUB_TYPE</div>
                    <mat-form-field appearance="outline">
                        <mat-select
                            [(value)]="subTypeSelected"
                            required
                            (selectionChange)="onModeChanged()"
                            [disabled]="this.isModifyStatus"
                        >
                            <mat-option value="none"><span translate>INDUSTRY_CONFIGURATOR.SELECT</span> </mat-option>
                            <mat-option *ngFor="let mode of this.subTokenModeList" [value]="mode.Value">
                                {{ mode.Name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-xl-6 columnCalVisibility">
                <div *ngIf="this.showallOptions" class="containerStepper">
                    <div class="EditionNameStyle" translate>INDUSTRY_CONFIGURATOR.SELECT_ISTANCE</div>
                    <mat-form-field appearance="outline">
                        <mat-select
                            [(value)]="instanceKey"
                            #instanceKeySelect
                            required
                            (selectionChange)="onInstanceKeyChanged()"
                            [disabled]="this.isModifyStatus"
                        >
                            <mat-option value="none"><span translate>INDUSTRY_CONFIGURATOR.SELECT</span> </mat-option>
                            <mat-option *ngFor="let instance of this.magocloudService.instanceList" [value]="instance.InstanceKey">
                                {{ instance.IKDescription }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div class="EditionNameStyle" translate>INDUSTRY_CONFIGURATOR.SELECT_SNAPSHOT</div>
                    <ms-snapshots-selection
                        [(defaultSnapshotID)]="selectedSnapshotID"
                        [(selecteInstanceKey)]="instanceKey"
                        [readonly]="this.isModifyStatus"
                        (snapshotSelectedValue)="setSnapshotValue($event)"
                    ></ms-snapshots-selection>
                </div>
            </div>
        </div>

        <div [class]="this.smallScreen ? 'text-left' : 'text-center'" *ngIf="this.storeRoleService?.IsInternal">
            <button
                mat-stroked-button
                color="secondary"
                [disabled]="
                    this.subTypeSelected == '' ||
                    this.subTypeSelected == 'none' ||
                    this.instanceKey == '' ||
                    this.instanceKey == 'none' ||
                    this.selectedSnapshotID == ''
                "
                matStepperNext
            >
                {{ this.nextString }}
            </button>
        </div>
        <div *ngIf="!this.functLoaded">
            <tb-loading></tb-loading>
        </div>
    </mat-step>
    <mat-step name="3-SelectEdition">
        <ng-template matStepLabel>
            <div>
                <span translate>INDUSTRY_CONFIGURATOR.SELECT_EDITION_NR_USER</span>
                <span *ngIf="this.selectedEditionDescription != ''" style="font-size: 0.8rem">
                    <br />
                    {{ this.selectedEditionDescription }}</span
                >
            </div>
        </ng-template>
        <div class="containerStepper">
            <ms-editions-list (oneEditionChange)="onEditionChangeEvent($event)"></ms-editions-list>
        </div>
        <div [class]="this.smallScreen ? 'text-left' : 'text-center'">
            <button
                mat-stroked-button
                color="secondary"
                [disabled]="!this.magocloudService.edition || this.magocloudService.edition.length == 0"
                matStepperNext
            >
                {{ this.nextString }}
            </button>
        </div>
    </mat-step>
    <mat-step name="3-functionalityIncluded">
        <div class="containerStepper">
            <ng-template matStepLabel>
                <span translate>MAGOWEB_CONFIGURATION.CHOOSEN_PACK</span><br />
                (<span
                    *ngIf="this.magocloudService?.currentIndustry != 'none' || this.magocloudService?.currentIndustry?.TranslatedName != ''"
                    style="font-size: 0.8rem"
                    >{{ this.magocloudService?.currentIndustry?.TranslatedName }}</span
                >)
            </ng-template>
            <div *ngIf="this.magocloudService?.functionalitygroupsAlwaysAvalilable.length == 0">
                <tb-loading></tb-loading>
            </div>
            <div *ngIf="this.magocloudService?.functionalitygroupsAlwaysAvalilable.length > 0">
                <div *ngIf="this.magocloudService?.functionalitygroupsAlwaysAvalilable.length > 0">
                    <ms-functionality-included
                        [functionalitygroups]="this.magocloudService?.functionalitygroupsAlwaysAvalilable"
                        [editionSelected]="this.magocloudService?.edition"
                        [currentIndustry]="this.magocloudService?.currentIndustry"
                        [currIndustryPurchInfo]="this.magocloudService?.currIndustryPurchInfo"
                        [moduleCode]="this.magocloudService?.moduleCode"
                        [version]="this.magocloudService?.version"
                        [countrySelected]="this.magocloudService?.countryValue"
                        [parent]="this.magocloudService?.moduleCode"
                    ></ms-functionality-included>
                </div>
                <div style="text-align: center">
                    <button mat-stroked-button color="secondary" matStepperPrevious>
                        {{ this.backString }}
                    </button>
                    <button mat-stroked-button color="secondary" matStepperNext>
                        {{ this.nextString }}
                    </button>
                </div>
            </div>
        </div>
    </mat-step>

    <mat-step name="4-SelectOptionalfunctionalities">
        <div class="containerStepper">
            <ng-template matStepLabel> <span translate>MAGOWEB_CONFIGURATION.OPTIONAL_MODULES</span><br /> </ng-template>
            <div *ngIf="this.functLoaded">
                <ms-functionalities-selection
                    [functionalitygroups]="this.magocloudService?.functionalitygroupsNoCAL"
                    [editionSelected]="this.magocloudService?.edition"
                    [currentIndustry]="this.magocloudService?.currentIndustry"
                    [currIndustryPurchInfo]="this.magocloudService?.currIndustryPurchInfo"
                    [moduleCode]="this.magocloudService?.moduleCode"
                    [version]="this.magocloudService?.version"
                    [countrySelected]="this.magocloudService?.countryValue"
                    [parent]="this.magocloudService?.moduleCode"
                ></ms-functionalities-selection>
            </div>
            <div class="text-center">
                <button mat-stroked-button color="secondary" matStepperPrevious>
                    {{ this.backString }}
                </button>
                <button mat-stroked-button color="secondary" [disabled]="setCountryDisabled()" (click)="enableButton()" matStepperNext>
                    {{ this.nextString }}
                </button>
            </div>
        </div>
        <div *ngIf="!this.functLoaded">
            <tb-loading></tb-loading>
        </div>
    </mat-step>

    <mat-step name="5-SelectCal" *ngIf="this.magocloudService.moduleCode != 'CART'">
        <div class="containerStepper">
            <ng-template matStepLabel> <span translate>MAGOWEB_CONFIGURATION.CAL_MODULES</span><br /> </ng-template>
            <div *ngIf="this.magocloudService?.totalCalFullNr == 0">
                <h3 translate>MAGOWEB_CONFIGURATION.INTRO_CAL_SELECTION</h3>
            </div>
            <div *ngIf="this.functLoaded">
                <ms-cal-selection
                    [CALFeature]="this.magocloudService?.CALFeature"
                    [productID]="this.magocloudService?.productID"
                    (featureClicked)="updateConfiguration()"
                ></ms-cal-selection>
            </div>
            <div class="text-center">
                <button mat-stroked-button color="secondary" matStepperPrevious>
                    {{ this.backString }}
                </button>
                <button mat-stroked-button color="secondary" matStepperNext *ngIf="false">
                    {{ this.nextString }}
                </button>
            </div>
        </div>
        <div *ngIf="!this.functLoaded">
            <tb-loading></tb-loading>
        </div>
    </mat-step>

    <mat-step name="6-SelectFunctions_horizontal" [completed]="!privacyNotSelected" *ngIf="false">
        <div class="containerStepper" style="width: 86%">
            <ng-template matStepLabel>
                <span translate> COMMONS.PRIVACY_AGREEMENT </span>
            </ng-template>
            <ms-privacy-agreement></ms-privacy-agreement>
        </div>
        <div class="text-center">
            <button mat-stroked-button color="secondary" matStepperPrevious>
                {{ this.backString }}
            </button>
        </div>
    </mat-step>
</mat-stepper>
